export default "../images/lock.svg?89da35b997fa5af91749a8c71018492a";